import { TablesInputProvider, useTablesInput } from 'providers/TablesInputProvider';
import TablesScreen from 'screens/TablesScreen';
import { HeroPage } from 'config/hero-covers';
import useOfflineQuery from 'hooks/useOfflineQuery';
import { useOperationsQuery } from 'generated/graphql';

const OperationsInner = () => {
  const { input, profileID, isQueryPaused } = useTablesInput();
  const [result, refetch] = useOfflineQuery('operations-query', useOperationsQuery, {
    variables: { input, profileID },
    pause: isQueryPaused,
    returnCachedDataWhileFetching: true,
  });
  return <TablesScreen heroPage={HeroPage.Operations} result={result} refetch={refetch} dataKey="operations" />;
};

const Operations = () => (
  <TablesInputProvider>
    <OperationsInner />
  </TablesInputProvider>
);

export default Operations;
